import React, { useEffect, useState } from "react";
import "./styles.scss";

import { useStateValue } from "../../store";
import { getAssessmentData } from "../../store/homeAction/action";

import Button from "../../common/button";
import { useNavigate } from "react-router-dom";

const AssessmentLanding = () => {
  const Navigate = useNavigate();
  const [questionValues, setQuestionValues] = useState(
    JSON.parse(sessionStorage.getItem("qtnValues"))
  );
  const [{ assessmentLanding }, dispatch] = useStateValue();

  //api trigger to get assessment data
  useEffect(() => {
    if (Object.keys(assessmentLanding)?.length === 0) {
      dispatch({
        type: "SET_IS_LOADING",
        value: true,
      });

      getAssessmentData((res, error) => {
        dispatch({
          type: "SET_ASSESSMENT_LANDING",
          data: res,
        });
        dispatch({
          type: "SET_IS_LOADING",
          value: false,
        });
        if (error) {
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: {
              severity: "error",
              message: "Something went wrong, Please try again.",
            },
          });
        }
      });
    }
  }, []);

  const handleUpdateValues = (value) => {
    sessionStorage.setItem(
      "qtnValues",
      JSON.stringify({ identify_person: value })
    );
    setQuestionValues((prev) => ({
      ...prev,
      identify_person: value,
    }));
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    setTimeout(() => {
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
      Navigate(`${process.env.REACT_APP_BASE}/assessment/question_${1}`);
    }, 500);
  };

  return (
    <>
      <div className="assessment-landing-container">
        {Object.keys(assessmentLanding)?.length !== 0 ? (
          <>
            <h3>{assessmentLanding?.assessemnet_for_whom?.title}</h3>
            <div className="description">
              <p>{assessmentLanding?.assessemnet_for_whom?.question}</p>
            </div>
            <div className="button-container">
              <Button
                onClick={() =>
                  handleUpdateValues(
                    assessmentLanding?.assessemnet_for_whom?.choice_1
                  )
                }
                className={`${
                  questionValues?.identify_person ===
                  assessmentLanding?.assessemnet_for_whom?.choice_1
                    ? "active"
                    : ""
                }`}
              >
                {assessmentLanding?.assessemnet_for_whom?.choice_1}
              </Button>
              <Button
                className={`${
                  questionValues?.identify_person ===
                  assessmentLanding?.assessemnet_for_whom?.choice_2
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  handleUpdateValues(
                    assessmentLanding?.assessemnet_for_whom?.choice_2
                  )
                }
              >
                {assessmentLanding?.assessemnet_for_whom?.choice_2}
              </Button>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default AssessmentLanding;
